/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeDefinitionDTO } from './AttributeDefinitionDTO';
import {
    AttributeDefinitionDTOFromJSON,
    AttributeDefinitionDTOFromJSONTyped,
    AttributeDefinitionDTOToJSON,
} from './AttributeDefinitionDTO';
import type { OpenRangeDTO } from './OpenRangeDTO';
import {
    OpenRangeDTOFromJSON,
    OpenRangeDTOFromJSONTyped,
    OpenRangeDTOToJSON,
} from './OpenRangeDTO';
import type { SecondaryStylingDTO } from './SecondaryStylingDTO';
import {
    SecondaryStylingDTOFromJSON,
    SecondaryStylingDTOFromJSONTyped,
    SecondaryStylingDTOToJSON,
} from './SecondaryStylingDTO';

/**
 * 
 * @export
 * @interface DashboardConfigDTO
 */
export interface DashboardConfigDTO {
    /**
     * 
     * @type {boolean}
     * @memberof DashboardConfigDTO
     */
    locked?: boolean;
    /**
     * 
     * @type {OpenRangeDTO}
     * @memberof DashboardConfigDTO
     */
    metricsStepsRange?: OpenRangeDTO;
    /**
     * 
     * @type {string}
     * @memberof DashboardConfigDTO
     */
    outliersDisplayMode?: DashboardConfigDTOOutliersDisplayModeEnum;
    /**
     * 
     * @type {SecondaryStylingDTO}
     * @memberof DashboardConfigDTO
     */
    secondaryStyling?: SecondaryStylingDTO;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardConfigDTO
     */
    showCompletion?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DashboardConfigDTO
     */
    showMetricBy?: DashboardConfigDTOShowMetricByEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardConfigDTO
     */
    showOriginalLineOnSmoothing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardConfigDTO
     */
    showPreviews?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DashboardConfigDTO
     */
    smoothing?: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardConfigDTO
     */
    smoothingAlgorithm?: DashboardConfigDTOSmoothingAlgorithmEnum;
    /**
     * 
     * @type {string}
     * @memberof DashboardConfigDTO
     */
    smoothingWindowMode?: DashboardConfigDTOSmoothingWindowModeEnum;
    /**
     * 
     * @type {AttributeDefinitionDTO}
     * @memberof DashboardConfigDTO
     */
    xaxisMetric?: AttributeDefinitionDTO;
    /**
     * 
     * @type {string}
     * @memberof DashboardConfigDTO
     */
    xaxisMode?: string;
    /**
     * 
     * @type {OpenRangeDTO}
     * @memberof DashboardConfigDTO
     */
    xaxisRange?: OpenRangeDTO;
    /**
     * 
     * @type {string}
     * @memberof DashboardConfigDTO
     */
    xaxisScale?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardConfigDTO
     */
    yaxisScale?: string;
}


/**
 * @export
 */
export const DashboardConfigDTOOutliersDisplayModeEnum = {
    None: 'none',
    Outline: 'outline'
} as const;
export type DashboardConfigDTOOutliersDisplayModeEnum = typeof DashboardConfigDTOOutliersDisplayModeEnum[keyof typeof DashboardConfigDTOOutliersDisplayModeEnum];

/**
 * @export
 */
export const DashboardConfigDTOShowMetricByEnum = {
    LineStyle: 'lineStyle',
    Color: 'color'
} as const;
export type DashboardConfigDTOShowMetricByEnum = typeof DashboardConfigDTOShowMetricByEnum[keyof typeof DashboardConfigDTOShowMetricByEnum];

/**
 * @export
 */
export const DashboardConfigDTOSmoothingAlgorithmEnum = {
    EmaCausal: 'emaCausal',
    GaussianCentered: 'gaussianCentered',
    SmaCausal: 'smaCausal',
    SmaCentered: 'smaCentered'
} as const;
export type DashboardConfigDTOSmoothingAlgorithmEnum = typeof DashboardConfigDTOSmoothingAlgorithmEnum[keyof typeof DashboardConfigDTOSmoothingAlgorithmEnum];

/**
 * @export
 */
export const DashboardConfigDTOSmoothingWindowModeEnum = {
    Causal: 'causal',
    Centered: 'centered',
    Ema: 'ema',
    Gaussian: 'gaussian'
} as const;
export type DashboardConfigDTOSmoothingWindowModeEnum = typeof DashboardConfigDTOSmoothingWindowModeEnum[keyof typeof DashboardConfigDTOSmoothingWindowModeEnum];


/**
 * Check if a given object implements the DashboardConfigDTO interface.
 */
export function instanceOfDashboardConfigDTO(value: object): value is DashboardConfigDTO {
    return true;
}

export function DashboardConfigDTOFromJSON(json: any): DashboardConfigDTO {
    return DashboardConfigDTOFromJSONTyped(json, false);
}

export function DashboardConfigDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardConfigDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'locked': json['locked'] == null ? undefined : json['locked'],
        'metricsStepsRange': json['metricsStepsRange'] == null ? undefined : OpenRangeDTOFromJSON(json['metricsStepsRange']),
        'outliersDisplayMode': json['outliersDisplayMode'] == null ? undefined : json['outliersDisplayMode'],
        'secondaryStyling': json['secondaryStyling'] == null ? undefined : SecondaryStylingDTOFromJSON(json['secondaryStyling']),
        'showCompletion': json['showCompletion'] == null ? undefined : json['showCompletion'],
        'showMetricBy': json['showMetricBy'] == null ? undefined : json['showMetricBy'],
        'showOriginalLineOnSmoothing': json['showOriginalLineOnSmoothing'] == null ? undefined : json['showOriginalLineOnSmoothing'],
        'showPreviews': json['showPreviews'] == null ? undefined : json['showPreviews'],
        'smoothing': json['smoothing'] == null ? undefined : json['smoothing'],
        'smoothingAlgorithm': json['smoothingAlgorithm'] == null ? undefined : json['smoothingAlgorithm'],
        'smoothingWindowMode': json['smoothingWindowMode'] == null ? undefined : json['smoothingWindowMode'],
        'xaxisMetric': json['xaxisMetric'] == null ? undefined : AttributeDefinitionDTOFromJSON(json['xaxisMetric']),
        'xaxisMode': json['xaxisMode'] == null ? undefined : json['xaxisMode'],
        'xaxisRange': json['xaxisRange'] == null ? undefined : OpenRangeDTOFromJSON(json['xaxisRange']),
        'xaxisScale': json['xaxisScale'] == null ? undefined : json['xaxisScale'],
        'yaxisScale': json['yaxisScale'] == null ? undefined : json['yaxisScale'],
    };
}

export function DashboardConfigDTOToJSON(value?: DashboardConfigDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'locked': value['locked'],
        'metricsStepsRange': OpenRangeDTOToJSON(value['metricsStepsRange']),
        'outliersDisplayMode': value['outliersDisplayMode'],
        'secondaryStyling': SecondaryStylingDTOToJSON(value['secondaryStyling']),
        'showCompletion': value['showCompletion'],
        'showMetricBy': value['showMetricBy'],
        'showOriginalLineOnSmoothing': value['showOriginalLineOnSmoothing'],
        'showPreviews': value['showPreviews'],
        'smoothing': value['smoothing'],
        'smoothingAlgorithm': value['smoothingAlgorithm'],
        'smoothingWindowMode': value['smoothingWindowMode'],
        'xaxisMetric': AttributeDefinitionDTOToJSON(value['xaxisMetric']),
        'xaxisMode': value['xaxisMode'],
        'xaxisRange': OpenRangeDTOToJSON(value['xaxisRange']),
        'xaxisScale': value['xaxisScale'],
        'yaxisScale': value['yaxisScale'],
    };
}

